/* eslint-disable import/no-unresolved */ /*This component is generated automatically by generateAssets.py. Do not edit it manually. 
The component getAsset() helps us to use our theme on the svgs and make importing easier.
To update please run `npm run generateAssets.ts`*/
import { colors } from "../../core/styles/colors";
import ArrowDown from "./ArrowDown.svg?react";
import ArrowLeft from "./ArrowLeft.svg?react";
import ArrowLeftSmall from "./ArrowLeftSmall.svg?react";
import ArrowRight from "./ArrowRight.svg?react";
import ArrowUp from "./ArrowUp.svg?react";
import Calendar from "./Calendar.svg?react";
import Category from "./Category.svg?react";
import CheckBoxRoundActive from "./CheckBoxRoundActive.svg?react";
import CheckBoxRoundInactive from "./CheckBoxRoundInactive.svg?react";
import CheckBoxSquareActive from "./CheckBoxSquareActive.svg?react";
import CheckBoxSquareInactive from "./CheckBoxSquareInactive.svg?react";
import Checkmark from "./Checkmark.svg?react";
import Clock from "./Clock.svg?react";
import Close from "./Close.svg?react";
import ContactDataIcon from "./ContactDataIcon.svg?react";
import Document from "./Document.svg?react";
import DocumentUpload from "./DocumentUpload.svg?react";
import EyeClosed from "./EyeClosed.svg?react";
import EyeOpen from "./EyeOpen.svg?react";
import FailureIcon from "./FailureIcon.svg?react";
import HumanFemaleBack from "./HumanFemaleBack.svg?react";
import HumanFemaleFront from "./HumanFemaleFront.svg?react";
import HumanFemaleLeft from "./HumanFemaleLeft.svg?react";
import HumanFemaleRight from "./HumanFemaleRight.svg?react";
import HumanHeadBack from "./HumanHeadBack.svg?react";
import HumanHeadFront from "./HumanHeadFront.svg?react";
import HumanHeadLeft from "./HumanHeadLeft.svg?react";
import HumanHeadRight from "./HumanHeadRight.svg?react";
import HumanMaleBack from "./HumanMaleBack.svg?react";
import HumanMaleFront from "./HumanMaleFront.svg?react";
import HumanMaleLeft from "./HumanMaleLeft.svg?react";
import HumanMaleRight from "./HumanMaleRight.svg?react";
import Info from "./Info.svg?react";
import Location from "./Location.svg?react";
import Logo from "./Logo.svg?react";
import LogoSmall from "./LogoSmall.svg?react";
import LogoTermin from "./LogoTermin.svg?react";
import MailSend from "./MailSend.svg?react";
import OptionsIcon from "./OptionsIcon.svg?react";
import Phone from "./Phone.svg?react";
import PhysiofitLogo from "./PhysiofitLogo.svg?react";
import Test from "./Test.svg?react";
import TherapiumLogo from "./TherapiumLogo.svg?react";

export type SVGName =
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowLeftSmall"
  | "ArrowRight"
  | "ArrowUp"
  | "Calendar"
  | "Category"
  | "CheckBoxRoundActive"
  | "CheckBoxRoundInactive"
  | "CheckBoxSquareActive"
  | "CheckBoxSquareInactive"
  | "Checkmark"
  | "Clock"
  | "Close"
  | "ContactDataIcon"
  | "Document"
  | "DocumentUpload"
  | "EyeClosed"
  | "EyeOpen"
  | "FailureIcon"
  | "HumanFemaleBack"
  | "HumanFemaleFront"
  | "HumanFemaleLeft"
  | "HumanFemaleRight"
  | "HumanHeadBack"
  | "HumanHeadFront"
  | "HumanHeadLeft"
  | "HumanHeadRight"
  | "HumanMaleBack"
  | "HumanMaleFront"
  | "HumanMaleLeft"
  | "HumanMaleRight"
  | "Info"
  | "Location"
  | "Logo"
  | "LogoSmall"
  | "LogoTermin"
  | "MailSend"
  | "OptionsIcon"
  | "Phone"
  | "PhysiofitLogo"
  | "Test"
  | "TherapiumLogo";

type SvgProps = {
  [key: string]: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
      primary?: string | undefined;
      secondary?: string | undefined;
    }
  >;
};
const svgs: SvgProps = {
  ArrowDown,
  ArrowLeft,
  ArrowLeftSmall,
  ArrowRight,
  ArrowUp,
  Calendar,
  Category,
  CheckBoxRoundActive,
  CheckBoxRoundInactive,
  CheckBoxSquareActive,
  CheckBoxSquareInactive,
  Checkmark,
  Clock,
  Close,
  ContactDataIcon,
  Document,
  DocumentUpload,
  EyeClosed,
  EyeOpen,
  FailureIcon,
  HumanFemaleBack,
  HumanFemaleFront,
  HumanFemaleLeft,
  HumanFemaleRight,
  HumanHeadBack,
  HumanHeadFront,
  HumanHeadLeft,
  HumanHeadRight,
  HumanMaleBack,
  HumanMaleFront,
  HumanMaleLeft,
  HumanMaleRight,
  Info,
  Location,
  Logo,
  LogoSmall,
  LogoTermin,
  MailSend,
  OptionsIcon,
  Phone,
  PhysiofitLogo,
  Test,
  TherapiumLogo,
};

type Props = React.SVGProps<SVGSVGElement> & {
  name: SVGName;
  primaryColor?: string;
  secondaryColor?: string;
  size?: number;
};
export const GenericSvg = (props: Props) => {
  const Icon = svgs[props.name as SVGName];
  // https://stackoverflow.com/questions/49358560/react-wrapper-react-does-not-recognize-the-staticcontext-prop-on-a-dom-elemen
  const { name, primaryColor, secondaryColor, size, ...rest } = props;
  return (
    <Icon
      {...rest}
      primary={primaryColor ?? colors.dark}
      secondary={secondaryColor ?? colors.light}
      height={size ?? props.height}
      width={size ?? props.width}
    />
  );
};
